import Command from './Command';
import common from '../common';

export default class WalkCommand extends Command {
	constructor() {
		super('ui_function_walk_bg_9slice');

		this.type = Command.TYPE_WALK;

		this.options = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10];
		this.signals.onVariableTouch = new P3.utils.MiniSignal();

		this.init();
	}

	init() {
		super.init('GAME.BLOCKS.WALK', 'ui_icon_walk');

		this.player.signals.moved.add(() => {
			this.signals.executionComplete.dispatch();
		}, this);

		this.on('pointertap', (e) => {
			e.stopPropagation();

			if (!this.canChangeVariable) {
				return;
			}
			this.signals.onVariableTouch.dispatch(this, e);
		});

		this.variableBackground.visible = this.variableActive;
		this.variableLabel.visible = this.variableActive;
	}

	destroy() {
		super.destroy();
	}

	setText(text) {
		if (!this.variableActive) {
			text = '';
		}

		this.variableLabel.text = `${text}`;
	}

	onPointerMove(event) {
		super.onPointerMove(event);

		/* if (this.y - this.height * 0.5 < 0) {
			this.y = this.height * 0.5;
		} else if (this.y + this.height * 0.5 > common.STAGE_HEIGHT) {
			this.y = common.STAGE_HEIGHT - this.height * 0.5;
		} */
	}

	execute() {
		this.player.move(this.player.direction, 1, this.player.aliendata.walkspeed);
	}
}
